import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertActionModalComponent } from '@app/trackvision/shared/pop-up/alert-action-modal/alert-action-modal.component';
import { PjudUnavailableModalComponent } from '@app/trackvision/shared/pop-up/pjud-unavailable-modal/pjud-unavailable-modal.component';

export const PJUD_UNAVAILABLE_MESSAGE =
  'El servicio de seguimiento PJUD no está disponible en este momento. Comuníquese con soporte.';

const UNAVAILABLE_PATTERNS = [
  'eai_again',
  'enotfound',
  'econnrefused',
  'econnreset',
  'etimedout',
  'err_network',
  'network error',
  'setting-pjud no disponible',
  'error al llamar a scraping-pjud',
];

export function isPjudServiceUnavailable(message?: string | null): boolean {
  if (!message) {
    return false;
  }
  const normalized = String(message).toLowerCase();
  return UNAVAILABLE_PATTERNS.some((pattern) => normalized.includes(pattern));
}

/** Traduce errores técnicos del backend a mensaje amigable para el usuario final. */
export function toPjudUserMessage(
  message?: string | null,
  fallback = 'No se pudo actualizar el seguimiento.'
): string {
  if (isPjudServiceUnavailable(message)) {
    return PJUD_UNAVAILABLE_MESSAGE;
  }
  return message || fallback;
}

export interface PjudAlertModalOptions {
  title?: string;
  /** Mensaje crudo del backend; si indica indisponibilidad, se usa el modal con correo de soporte. */
  rawMessage?: string | null;
}

export function openPjudAlertModal(
  modalService: NgbModal,
  message: string,
  options: PjudAlertModalOptions = {}
): void {
  const title = options.title ?? 'Seguimiento PJUD';
  const showSupportContact =
    isPjudServiceUnavailable(options.rawMessage) || message === PJUD_UNAVAILABLE_MESSAGE;

  if (showSupportContact) {
    const modalRef = modalService.open(PjudUnavailableModalComponent, { size: 'sm', centered: true });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    return;
  }

  const modalRef = modalService.open(AlertActionModalComponent, { size: 'sm', centered: true });
  modalRef.componentInstance.title = title;
  modalRef.componentInstance.message = message;
}
